__turbopack_context__.v({
  "meta": "_0L88Oq_meta",
  "name": "_0L88Oq_name",
  "row": "_0L88Oq_row",
  "rowPressable": "_0L88Oq_rowPressable",
  "text": "_0L88Oq_text",
  "thumb": "_0L88Oq_thumb",
  "thumbIcon": "_0L88Oq_thumbIcon",
  "thumbPage": "_0L88Oq_thumbPage",
  "thumbPainted": "_0L88Oq_thumbPainted",
  "trailing": "_0L88Oq_trailing",
});
